module.exports = __webpack_public_path__ + "img/logo-2.d84ff2fd.svg";